module.exports = __webpack_public_path__ + "static/media/2.71cef28b.jpg";